import { matchPath, useLocation } from 'react-router'
import { useEffect, useState } from 'react'
import router from 'constants/router'

const findMatchedRoutes = (routes, pathname = global.location.pathname) => {
  return (routes || router).reduce((acc, route) => {
    const matched = matchPath(pathname, {
      path: route.path,
      exact: route.exact,
    })

    if (matched) {
      acc.push(route)

      if (route?.routes) {
        acc = acc.concat(findMatchedRoutes(route.routes, pathname))
      }
    }

    return acc
  }, [])
}

export default findMatchedRoutes

export function useFindMatchedRoutes(routes) {
  const location = useLocation()
  const [matchedRoutes, setMatchedRoutes] = useState([])

  useEffect(() => {
    setMatchedRoutes(findMatchedRoutes(routes, location.pathname))
  }, [routes, location.pathname])

  return matchedRoutes
}
